import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Activity, Loader2, XCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Ativar() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking"); // checking | error
  const token = params.get("token");

  useEffect(() => {
    let done = false;
    const run = async () => {
      if (!token) return setState("error");
      try {
        const r = await fetch(`${API}/api/auth/activate-link`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        const d = await r.json();
        if (!r.ok || !d.token) throw new Error();
        localStorage.setItem("veloclin_token", d.token);
        localStorage.removeItem("veloclin_auth");
        if (!done) window.location.assign("/assinar");
      } catch {
        if (!done) setState("error");
      }
    };
    run();
    return () => { done = true; };
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-blue-950 px-5">
      <div data-testid="ativar-card" className="w-full max-w-md rounded-3xl border border-white/10 bg-white p-8 text-center shadow-2xl">
        <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-600"><Activity className="h-6 w-6 text-white" strokeWidth={2.5} /></div>
        {state === "checking" ? (
          <>
            <Loader2 className="mx-auto mt-2 h-9 w-9 animate-spin text-blue-600" />
            <h1 className="mt-4 font-heading text-xl font-bold text-slate-900">Reativando sua conta…</h1>
            <p className="mt-1 text-sm text-slate-500">Todos os seus dados serão mantidos.</p>
          </>
        ) : (
          <>
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-rose-50 text-rose-600"><XCircle className="h-7 w-7" /></div>
            <h1 className="mt-4 font-heading text-xl font-bold text-slate-900">Link inválido ou expirado</h1>
            <p className="mt-1 text-sm text-slate-500">Faça login para concluir sua assinatura.</p>
            <a href="/login" data-testid="ativar-login-link" className="mt-5 inline-block w-full rounded-xl bg-blue-600 py-3 text-sm font-bold text-white hover:bg-blue-700">Ir para o login</a>
          </>
        )}
      </div>
    </div>
  );
}
